import { useState } from "react";
import { faqItems } from "@/mocks/home";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full bg-background-100 py-14 md:py-24">
      <div className="max-w-4xl mx-auto px-6 md:px-10">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block font-heading tracking-[0.32em] text-xs font-semibold text-primary-600">
            FAQ
          </span>
          <h2 className="mt-3 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight tracking-tight">
            궁금한 모든 것
          </h2>
        </div>

        <div className="rounded-xl bg-background-50 border border-background-200/70 divide-y divide-background-200/70 overflow-hidden">
          {faqItems.map((item, i) => (
            <div key={item.q}>
              <button
                type="button"
                onClick={() => setOpen(open === i ? null : i)}
                className="w-full flex items-center justify-between gap-3 sm:gap-6 px-4 sm:px-6 py-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
              >
                <span className="flex min-w-0 items-center gap-3 sm:gap-4">
                  <span className="w-8 h-8 min-w-8 min-h-8 shrink-0 aspect-square flex items-center justify-center rounded-md bg-primary-100 text-primary-700 font-heading font-bold text-sm">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="min-w-0 font-heading text-base md:text-lg font-semibold text-foreground-950">
                    {item.q}
                  </span>
                </span>
                <i
                  className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform ${
                    open === i ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {open === i && (
                <div className="px-6 pb-6 pl-[76px] text-sm text-foreground-700 leading-relaxed">
                  {item.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
